"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rpmReadingMapper = exports.createMessageResponseFromPayload = exports.mediaMapper = void 0;
exports.messagesMapper = messagesMapper;
exports.messageMapper = messageMapper;
exports.suggestedCliniciansMapper = suggestedCliniciansMapper;
exports.visibleToMapper = visibleToMapper;
exports.documentMapper = documentMapper;
exports.videoMapper = videoMapper;
exports.imageMapper = imageMapper;
exports.linkMapper = linkMapper;
exports.audioMapper = audioMapper;
exports.groupAssetsMapper = groupAssetsMapper;
exports.recipientInfoMapper = recipientInfoMapper;
exports.visibleToUnmapper = visibleToUnmapper;
exports.messageUnmapper = messageUnmapper;
exports.mapMessageToPreviewData = mapMessageToPreviewData;
const models_1 = require("../models");
const utils_1 = require("../utils");
const MapperUtils_1 = require("./MapperUtils");
const lodash_1 = require("lodash");
function messagesMapper(messageResponse, userDirectory, organization, makeMessage) {
    const reversedMessages = messageResponse.data;
    const alteredMessages = {
        messages: [],
        mediaList: [],
    };
    for (const message of reversedMessages) {
        const finalMessage = messageMapper(message, userDirectory, organization);
        if (finalMessage) {
            const pushMessage = makeMessage(finalMessage);
            if (models_1.MESSAGE_CONTENT_MEDIA_TYPE.includes(message.contentType)) {
                alteredMessages.mediaList.push(pushMessage);
            }
            alteredMessages.messages.push(pushMessage);
        }
    }
    return Object.assign({ messages: alteredMessages.messages, mediaList: alteredMessages.mediaList, id: messageResponse.id, lastMessageRead: messageResponse.lastMessageRead, unreadCount: messageResponse.unreadCount, isMember: messageResponse.isMember }, (0, MapperUtils_1.paginationMapper)(messageResponse));
}
const isMessageStarred = (messageData, user) => {
    var _a;
    const visibleToSelf = (_a = messageData === null || messageData === void 0 ? void 0 : messageData.visibleTo) === null || _a === void 0 ? void 0 : _a.find((visibleTo) => visibleTo.id === user.id);
    return visibleToSelf ? visibleToSelf.haveStarMarked === 1 : false;
};
function messageMapper(messageData, userDirectory, organization) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ id: messageData._id, messageId: messageData.messageId, body: messageData.body, fallbackMessage: messageData.fallbackMessage, createdAt: messageData.createdAt, updatedAt: messageData.updatedAt, from: messageData.user, chatType: models_1.CHAT_TYPE[messageData.chatType], chatId: (0, utils_1.getChatIdFromMessage)(messageData.chatType, messageData.to, messageData.user, organization.userProfile.id), contentType: models_1.MESSAGE_CONTENT_TYPE[messageData.contentType], status: models_1.MESSAGE_STATUS[messageData.status], type: models_1.MESSAGE_TYPE[messageData.type], isEdited: messageData.isEdited ? messageData.isEdited : false, isStarred: isMessageStarred(messageData, organization.userProfile) }, (messageData.audios && { audios: messageData.audios })), (messageData.documents && {
        documents: documentMapper(messageData.documents),
    })), (messageData.images && {
        images: imageMapper(messageData.images),
    })), (messageData.links && {
        links: linkMapper(messageData.links),
    })), (messageData.videos && {
        videos: videoMapper(messageData.videos),
    })), (messageData.visibleTo && {
        visibleTo: visibleToMapper(messageData.visibleTo, userDirectory),
    })), { senderType: models_1.MESSAGE_SENDER_TYPE[(messageData.senderType
            ? messageData.senderType
            : "USER")] }), (messageData.isForwarded && {
        isForwarded: messageData.isForwarded,
    })), (messageData.forwardedFrom && {
        forwardedFrom: Object.assign(Object.assign({}, messageData.forwardedFrom), { chatType: models_1.CHAT_TYPE[messageData.forwardedFrom.chatType] }),
    })), { isResend: messageData.isResend }), (messageData.isVisibleToPatient && {
        isVisibleToPatient: messageData.isVisibleToPatient,
    })), (messageData.isVisibleToPhysician && {
        isVisibleToPhysician: messageData.isVisibleToPhysician,
    })), (messageData.replyTo &&
        messageData.replyTo._id && {
        replyTo: messageMapper(messageData.replyTo, userDirectory, organization),
    })), { isSender: messageData.user === organization.userProfile.id }), (messageData.voiceMessage && {
        voiceMessage: audioMapper(messageData.voiceMessage),
    })), (messageData.reminder && {
        reminder: Object.assign(Object.assign({ action: messageData.reminder.action && Object.assign(Object.assign(Object.assign({}, messageData.reminder.action), { actionStatus: models_1.ACTION_STATUS[messageData.reminder.action
                    .actionStatus], actionExecuted: models_1.AVAILABLE_ACTIONS[messageData.reminder.action
                    .actionExecuted], actionExecutedAt: messageData.reminder.action.actionExecutedAt, actionExecutedBy: messageData.reminder.action.actionExecutedBy }), messageData.reminder.action.actionMeta) }, (messageData.reminder.reminderType && {
            reminderType: models_1.REMINDER_TYPE[messageData.reminder.reminderType],
        })), ((_a) => {
            var { action, reminderType } = _a, rest = __rest(_a, ["action", "reminderType"]);
            return rest;
        })(messageData.reminder)),
    })), (messageData.form && { form: messageData.form })), (messageData.suggestedClinicians && {
        suggestedClinicians: suggestedCliniciansMapper(messageData.suggestedClinicians),
    })), (messageData.suggestedCliniciansSearchRadius && {
        suggestedCliniciansSearchRadius: messageData.suggestedCliniciansSearchRadius,
    })), (messageData.suggestedCliniciansDepartments && {
        suggestedCliniciansDepartments: messageData.suggestedCliniciansDepartments,
    })), (messageData.mentionedUsers && {
        mentionedUsers: messageData.mentionedUsers,
    })), (messageData.location && {
        location: messageData.location,
    }));
}
function suggestedCliniciansMapper(suggestedCliniciansResponse) {
    return suggestedCliniciansResponse.map((suggestedCliniciansItem) => {
        return {
            id: suggestedCliniciansItem.id,
            patients: patientMapper(suggestedCliniciansItem.patients),
        };
    });
}
function patientMapper(patients) {
    return patients.map((patient) => {
        return {
            id: patient.id,
            distance: patient.distance,
        };
    });
}
function visibleToMapper(visibleToResponse, userDirectory) {
    const mappedVisibleTo = [];
    if (visibleToResponse) {
        for (const visibleTo of visibleToResponse) {
            mappedVisibleTo.push({
                acknowledgedAt: visibleTo.acknowledgedAt,
                acknowledgementRequired: visibleTo.acknowledgementRequired,
                deliveredAt: visibleTo.deliveredAt,
                haveStarMarked: visibleTo.haveStarMarked,
                id: visibleTo.id,
                isAcknowledged: visibleTo.isAcknowledged,
                isDelivered: visibleTo.isDelivered,
                isRead: visibleTo.isRead,
                isSent: visibleTo.isSent,
                readAt: visibleTo.readAt,
                sentAt: visibleTo.sentAt,
                starMarkedAt: visibleTo.starMarkedAt,
            });
        }
        if (mappedVisibleTo.length > 0) {
            const currentUserId = userDirectory.currentUserProfile.id;
            const currentUserIndex = mappedVisibleTo.findIndex(item => item.id === currentUserId);
            if (currentUserIndex !== -1) {
                const [currentUser] = mappedVisibleTo.splice(currentUserIndex, 1);
                mappedVisibleTo.unshift(currentUser);
            }
        }
    }
    return mappedVisibleTo;
}
function documentMapper(documentData) {
    if (documentData) {
        return documentData.map(document => {
            return {
                size: document.size,
                docType: models_1.MESSAGE_CONTENT_DOCUMENT_TYPE[document.docType],
                text: document.text,
                url: document.url,
            };
        });
    }
    return [];
}
function videoMapper(videosData) {
    if (videosData) {
        return videosData.map(videoData => {
            return {
                url: videoData.url,
                text: videoData.text,
                thumbnail: videoData.thumbnail,
            };
        });
    }
    return [];
}
function imageMapper(imagesData) {
    if (imagesData) {
        return imagesData.map(imageData => {
            return {
                url: imageData.url,
                text: imageData.text,
            };
        });
    }
    return [];
}
function linkMapper(linksData) {
    if (linksData) {
        return linksData.map(linksData => {
            return linksData;
        });
    }
    return [];
}
function audioMapper(voiceData) {
    if (voiceData) {
        return {
            url: voiceData.url,
            duration: voiceData.duration,
            mediaType: voiceData.mediaType,
        };
    }
}
function groupAssetsMapper(messageResponse, userDirectory, organization, makeMessage) {
    const messagesData = [];
    for (const message of messageResponse.data) {
        const finalMessage = messageMapper(message, userDirectory, organization);
        if (finalMessage) {
            const pushMessage = makeMessage(finalMessage);
            messagesData.push(pushMessage);
        }
    }
    return {
        limit: messageResponse.limit,
        page: messageResponse.page,
        total: messageResponse.total,
        data: messagesData,
    };
}
function recipientInfoMapper(recipientInfoResponse, userDirectory) {
    return {
        id: recipientInfoResponse._id,
        visibleTo: (recipientInfoResponse === null || recipientInfoResponse === void 0 ? void 0 : recipientInfoResponse.visibleTo)
            ? visibleToMapper(recipientInfoResponse.visibleTo, userDirectory)
            : [],
    };
}
function visibleToUnmapper(visibleTo) {
    return visibleTo.map((visibleToItem) => {
        return {
            isSent: visibleToItem.isSent,
            sentAt: visibleToItem.sentAt,
            isDelivered: visibleToItem.isDelivered,
            deliveredAt: visibleToItem.deliveredAt,
            isRead: visibleToItem.isRead,
            readAt: visibleToItem.readAt,
            acknowledgementRequired: visibleToItem.acknowledgementRequired,
            isAcknowledged: visibleToItem.isAcknowledged,
            acknowledgedAt: visibleToItem.acknowledgedAt,
            haveStarMarked: visibleToItem.haveStarMarked,
            starMarkedAt: visibleToItem.starMarkedAt,
            id: visibleToItem.id,
        };
    });
}
function messageUnmapper(messageData) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ __v: 0, _id: messageData.id, messageId: messageData.messageId, to: messageData.chatId, user: messageData.from, body: messageData.body, fallbackMessage: messageData.fallbackMessage }, (messageData.form && { form: messageData.form })), { createdAt: messageData.createdAt, updatedAt: messageData.updatedAt, chatType: messageData.chatType, contentType: messageData.contentType, status: messageData.status, type: messageData.type, images: messageData.images, audios: messageData.audios, videos: messageData.videos, links: messageData.links, documents: messageData.documents }), (messageData.reminder && { reminder: messageData.reminder })), (messageData.voiceMessage && { voiceMessage: messageData.voiceMessage })), (messageData.visibleTo && {
        visibleTo: visibleToUnmapper(messageData.visibleTo),
    })), (messageData.senderType && { senderType: messageData.senderType })), { isForwarded: messageData.isForwarded, isResend: messageData.isResend, isVisibleToPatient: messageData.isVisibleToPatient, isVisibleToPhysician: messageData.isVisibleToPhysician }), (messageData.suggestedClinicians && {
        suggestedClinicians: messageData.suggestedClinicians,
    })), (messageData.suggestedCliniciansDepartments && {
        suggestedCliniciansDepartments: messageData.suggestedCliniciansDepartments,
    })), (messageData.suggestedCliniciansSearchRadius && {
        suggestedCliniciansSearchRadius: messageData.suggestedCliniciansSearchRadius,
    })), (messageData.forwardedFrom && {
        forwardedFrom: messageData.forwardedFrom,
    })), (messageData.location && {
        location: messageData.location,
    }));
}
function mapMessageToPreviewData(messageData) {
    const commonData = {
        id: messageData.id,
        userId: messageData.from,
    };
    if (messageData.images && messageData.images.length > 0) {
        return Object.assign(Object.assign({}, commonData), { media: (0, exports.mediaMapper)(messageData.images), mediaType: models_1.MESSAGE_CONTENT_TYPE.IMAGE });
    }
    else if (messageData.videos && messageData.videos.length > 0) {
        return Object.assign(Object.assign({}, commonData), { media: (0, exports.mediaMapper)(messageData.videos), mediaType: models_1.MESSAGE_CONTENT_TYPE.VIDEO });
    }
    else if (messageData.voiceMessage) {
        return Object.assign(Object.assign({}, commonData), { 
            //media: { url: messageData.voiceMessage.url },
            media: (0, exports.mediaMapper)(new Array(messageData.voiceMessage)), mediaType: models_1.MESSAGE_CONTENT_TYPE.VOICE });
    }
    else if (messageData.documents && messageData.documents.length > 0) {
        return Object.assign(Object.assign({}, commonData), { media: (0, exports.mediaMapper)(messageData.documents), type: models_1.ATTACHMENT_TYPE[messageData.documents[0].docType], mediaType: models_1.MESSAGE_CONTENT_TYPE.DOCUMENT });
    }
    else
        return undefined;
}
const mediaMapper = (media) => {
    return media.map((mediaItem) => {
        return Object.assign(Object.assign(Object.assign(Object.assign({ url: mediaItem.url }, (mediaItem.text && { caption: mediaItem.text })), (mediaItem.thumbnail && { thumbnail: mediaItem.thumbnail })), (mediaItem.duration && { duration: mediaItem.duration })), (mediaItem.mediaType && { mediaType: mediaItem.mediaType }));
    });
};
exports.mediaMapper = mediaMapper;
const createMessageResponseFromPayload = (messagePayload, userDirectory, mediaDraft) => {
    var _a, _b;
    const currentTimestamp = new Date().getTime();
    const userInfo = userDirectory.currentUserProfile;
    const containsMedia = !(0, lodash_1.isEmpty)(mediaDraft);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ __v: 0, 
        // Keyed off messageId rather than the clock: two messages created in the
        // same millisecond would otherwise share an _id, and the upsert dedupes by
        // id — collapsing a burst of sends into one. Replaced by the real document
        // id when the server echo arrives, which matches on messageId.
        _id: messagePayload.messageId, messageId: messagePayload.messageId, body: messagePayload.body, fallbackMessage: messagePayload.body, createdAt: currentTimestamp, updatedAt: currentTimestamp, user: userInfo.id, chatType: messagePayload.chatType, to: messagePayload.to, contentType: messagePayload.contentType, status: models_1.MESSAGE_STATUS.PENDING, type: messagePayload.type, mentionedUsers: messagePayload.mentionedUsers, audios: [], 
        // Without a draft — recovering a send from the outbox — the payload is the
        // only source left, and it already carries the uploaded URLs: the media was
        // put in S3 before the message was ever emitted.
        documents: containsMedia &&
            (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.mediaFile.isDoc()) &&
            messagePayload.documents &&
            messagePayload.documents.length > 0
            ? [
                Object.assign(Object.assign({}, messagePayload.documents[0]), { url: mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.uploadedUrl }),
            ]
            : messagePayload.documents || [], images: containsMedia && (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.mediaFile.isImage())
            ? [
                {
                    url: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.uploadedUrl) || "",
                    text: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.text) || "",
                },
            ]
            : messagePayload.images || [] }, (messagePayload.voiceMessage && {
        voiceMessage: Object.assign(Object.assign({}, messagePayload.voiceMessage), (containsMedia && { url: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.uploadedUrl) || "" })),
    })), { links: messagePayload.links || [], videos: containsMedia && (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.mediaFile.isVideo())
            ? [
                {
                    url: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.uploadedUrl) || "",
                    thumbnail: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.uploadedThumbnailUrl) || "",
                    duration: (_a = messagePayload.videos) === null || _a === void 0 ? void 0 : _a[0].duration,
                    text: (mediaDraft === null || mediaDraft === void 0 ? void 0 : mediaDraft.text) || "",
                },
            ]
            : messagePayload.videos || [], visibleTo: [], senderType: models_1.MESSAGE_SENDER_TYPE.USER, isForwarded: false, isResend: (_b = messagePayload.isResend) !== null && _b !== void 0 ? _b : false, isVisibleToPatient: false, isVisibleToPhysician: false }), (messagePayload.reminder && {
        reminder: messagePayload.reminder,
    })), (messagePayload.form && {
        form: messagePayload.form,
    })), { senderInfo: {
            _id: userInfo.id,
            appName: userInfo.name,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            status: userInfo.status,
        } }), (messagePayload.replyTo && {
        replyTo: messagePayload.replyTo,
    })), (messagePayload.location && {
        location: messagePayload.location,
    }));
};
exports.createMessageResponseFromPayload = createMessageResponseFromPayload;
const rpmReadingMapper = (rpmReadingData, userDirectory, organization) => __awaiter(void 0, void 0, void 0, function* () {
    const rpmReadingResponse = yield Promise.all(rpmReadingData.data.map(data => messageMapper(data, userDirectory, organization))).then(results => results.filter(data => data !== undefined));
    return {
        data: rpmReadingResponse,
        limit: rpmReadingData.limit,
        hasNext: rpmReadingData.hasNext,
    };
});
exports.rpmReadingMapper = rpmReadingMapper;
